import script from "./TImportacoes.vue?vue&type=script&setup=true&lang=ts"
export * from "./TImportacoes.vue?vue&type=script&setup=true&lang=ts"

import "./TImportacoes.vue?vue&type=style&index=0&id=ca77b628&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca77b628"]])

export default __exports__